import CatalogService from '@/services/catalog.service'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage } from '@/utils/localStorage'
import { errorNotification } from '@/utils/notification'

export default {
  async getListCatalogByOulet ({ commit }, storeId) {
    commit('common/SET_LOADING', true, { root: true })
    const currenStore = getItemByLocalStorage(localStorageKey.STORE_ID)
    return CatalogService.getCategoryByOutlet(storeId || currenStore, '', 1)
      .then(response => {
        var pages = []
        let categories = response.data.items || []
        if (response.data && response.data.maxPage > 1 && response.data.page === 1) {
          for (let i = 1; i < response.data.maxPage; i++) {
            pages.push(i + 1)
          }
          return Promise.all(pages.map(page => CatalogService.getCategoryByOutlet(storeId || currenStore, '', page)))
            .then(results => {
              const items = results.reduce((prev, catalog) => [...prev, ...(catalog.data.items || [])], [])
              categories = [...categories, ...items]
              commit('SET_LIST_CATALOG', categories)
              commit('common/SET_LOADING', false, { root: true })
            })
            .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
        } else {
          commit('SET_LIST_CATALOG', categories)
          commit('common/SET_LOADING', false, { root: true })
        }
      })
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  },

  async getCategoriesFilter ({ commit, state }, payload) {
    payload.query = { ...state.query, ...payload.query }
    if (payload.query.page === 1) {
      commit('SET_LOADING_CATEGORIES', true)
    }
    return CatalogService.getCategoriesFilter(payload.query)
      .then(store => {
        if (store) {
          commit('SET_LIST_CATALOG_FILTER', { query: payload.query, categories: store.data.items || [], maxPage: store.data.maxPage, currentPage: store.data.page })
          commit('SET_LOADING_CATEGORIES', false)
        } else {
          commit('SET_LIST_CATALOG_FILTER', [])
          commit('SET_LOADING_CATEGORIES', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },

  clearCatalogData ({ commit }) {
    commit('SET_LIST_CATALOG', [])
  }
}
